<script>
  import FilterSelectionDialog from "../../components/filter/FilterSelectionDialog.svelte";
  import { createLoadGraphFilters } from "./LoadGraphFilters.js";
  import FilterSelectionButton from "../../components/filter/FilterSelectionButton.svelte";
  import GeneralButton from "../../components/button/GeneralButton.svelte";
  import { translate } from "../../i18n/i18next.js";
  import { 
    groupFilterInput,
    resFilterInput,
    procFilterInput,
    shiftFilterInput, 
    Filters,
  } from "./loadGraphStore.js";

  // Props for the selection boxes

  export let option_resourceCodes;
  export let option_processes;
  export let option_groups;
  export let option_shifts;
  export let handleClearAllFilters
  export let onClose;

  const applyPreloadedSettings = (options, preload) => {
    if (!preload || preload.length === 0) return options;

    return options.map((obj) => {
      if (preload.includes(obj.text)) {
        return { ...obj, excluded: true };
      }
      return obj;
    });
  };

  if ($groupFilterInput) {
    option_groups = applyPreloadedSettings(option_groups, $groupFilterInput);
    Filters.update(filters => {
      filters["GroupFilter"].items = option_groups;
      return filters;
    });
  }

  if ($resFilterInput) {
    option_resourceCodes = applyPreloadedSettings(option_resourceCodes, $resFilterInput);
    Filters.update(filters => {
      filters["ResCodeFilter"].items = option_resourceCodes;
      return filters;
    });
  }

  if ($procFilterInput) {
    option_processes = applyPreloadedSettings(option_processes, $procFilterInput);
    Filters.update(filters => {
      filters["ProcessFilter"].items = option_processes;
      return filters;
    });
  }

  if ($shiftFilterInput) {
    option_shifts = applyPreloadedSettings(option_shifts, $shiftFilterInput);
    Filters.update(filters => {
      filters["ShiftFilter"].items = option_shifts;
      return filters;
    });
  }
  function handleFiltersChange(filter) {
    Filters.update(filters => {
      return {...filters, [filter.name]: filter}
    })
  }

  $: {
    groupFilterInput.set(option_groups.filter((item) => item.excluded).map((item) => item.text));
    resFilterInput.set(option_resourceCodes.filter((item) => item.excluded).map((item) => item.text));
    procFilterInput.set(option_processes.filter((item) => item.excluded).map((item) => item.text));
    shiftFilterInput.set(option_shifts.filter((item) => item.excluded).map((item) => item.text));
  }
</script>

<FilterSelectionDialog
  onClose={onClose}
>
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["GroupFilter"]}
    items={option_groups}
  />
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["ResCodeFilter"]}
    items={option_resourceCodes}
  />
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["ProcessFilter"]}
    items={option_processes}
  />
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["ShiftFilter"]}
    items={option_shifts}
  />
  <GeneralButton buttonType="secondary" buttonFunction={handleClearAllFilters}>
    {translate("frontend:filters.clearAllFilters")}
  </GeneralButton>
</FilterSelectionDialog>
